<ng-template [ngIf]=fondoLiquidatiForm>
<div class="col-sm-12 coldx">
	<h4 *ngIf="!inserimento">Modifica dati - {{labelLiquidatoInitCap}}</h4>
	<h4 *ngIf="inserimento">Inserimento dati - {{labelLiquidatoInitCap}}</h4>

	<ng-template [ngIf]="inserimento">
		<div class="col-sm-12 coldx" 
			[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
			<h4 *ngIf="title">{{title}}</h4>
			<form class="cerca_grey">
				<div class="row">
					<p class="col-sm-12">
						<label for="cerca-sez-ec-liq-lbl">Cerca</label> <input id="cerca-sez-ec-liq-lbl" type="text" #searchItem (keyup)="0" class="form-control"
							placeholder="Inserisci numero" />
					</p>
				</div>
			</form>
			<ng-template [ngIf]="esitiList && esitiList?.length > 0">
				<ul id="controparticollapse" class="controparti">

					<ng-template ngFor let-esito
						[ngForOf]="esitiList | searchFilter : searchItem.value : 'numeroEsito'  ">
						<li class="panel">
							<div class="controparte">
								<p class="col-xs-12 col-sm-2">
									<button class="btn btn-primary associa" (click)="associaEsito(esito);"
										type="submit">Associa</button>
								</p>
								<h4 class="titolo col-sm-2">
									{{esito.tipoEsito?.label}}
								</h4>

								<p class="col-sm-2">
									N&deg;: <strong>{{esito.numeroEsito}}</strong>
								</p>
								<p class="col-sm-2">
									Data deposito:
									<strong>{{esito.dataDeposito ? (esito.dataDeposito | date:'dd/MM/yyyy'): ''}}</strong>
								</p> 
								<p class="col-sm-2">
									Data notifica:
									<strong>{{esito.dataNotifica ? (esito.dataNotifica | date:'dd/MM/yyyy') : ''}}</strong>
								</p>
								<p class="col-sm-2">
									Definitivo: <strong>{{esito.definitivo ? "Si" :	"No"}}</strong>
								</p>
							</div>
						</li>
					</ng-template>
				</ul>
			</ng-template>
			<ng-template [ngIf]="esitiList?.length === 0 && msgNoBeneficiari">
				<p>{{msgNoBeneficiari}}</p>
			</ng-template>
		</div>
	</ng-template>

	<ng-template [ngIf]="fondoLiquidatiForm">
		<div class="col-sm-12 coldx" 
			[ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
			<div class="tab-content">
	<form [formGroup]="fondoLiquidatiForm" (ngSubmit)="save();">
		<div class="row" *ngIf="esito" esito_entity_view [element]="esito"></div>
		<div class="container_conteggi">
			<div *ngFor="let totImporti of [( getSum( request.importoLiquidato.importo , request.importoLiquidato.interessi, request.importoLiquidato.sanzioni ) )]">
			<!-- <div *ngFor="let speseGenerali of [( getSum( request.costoGestioneLiquidato.diritti , request.costoGestioneLiquidato.onorari ) | percentage:15 )]">
			<div *ngFor="let totImponibile of [( getSum( request.costoGestioneLiquidato.diritti , request.costoGestioneLiquidato.onorari , speseGenerali ) )]"> -->
			<div *ngFor="let cpaImporto of [( request.costoGestioneLiquidato.compenso | percentage : cpaPerc )]">
			<div *ngFor="let ivaImporto of [( getSum( request.costoGestioneLiquidato.compenso , cpaImporto ) | percentage : ivaPerc )]">
			<div *ngFor="let ritenutaAcconto of [( request.costoGestioneLiquidato.flagRitenutaAcconto ? ( request.costoGestioneLiquidato.compenso | percentage:20) : 0 )]">
			<div *ngFor="let totSpeseLite of [( getDiff( getSum( request.costoGestioneLiquidato.compenso , cpaImporto , ivaImporto ) , ritenutaAcconto ))]">
			<div *ngFor="let totAltriImporti of [( getSum( request.altroImportoLiquidato.speseRegistrazione , request.altroImportoLiquidato.contributoUnificato ,
														   request.altroImportoLiquidato.altroImporto , request.altroImportoLiquidato.rimborsoTerzoPignorato ) )]">
			<div *ngFor="let totComplessivo of [( getDiff( getSum( totImporti , request.costoGestioneLiquidato.compenso , cpaImporto , ivaImporto , totAltriImporti ) , ritenutaAcconto ))]">
				<div class="row container_fieldset">
					<fieldset class="form-group">
						<legend>Importi</legend>
						<div textInputCurrency [labelInput]="'Importo'" formControlName="importo" [(ngModel)]="request.importoLiquidato.importo" [mandatory]="true"></div>
						<div textInputCurrency [labelInput]="'Interessi'" formControlName="interessi" [(ngModel)]="request.importoLiquidato.interessi"></div>
						<div textInputCurrency [labelInput]="'Sanzioni'" formControlName="sanzioni" [(ngModel)]="request.importoLiquidato.sanzioni"></div>
						<div><p class="col-sm-offset-7 col-sm-2 alignright"><label for="tot-imp-lbl">Totale importi</label></p>
							<p class="col-sm-3"><input id="tot-imp-lbl" class="alignright totale form-control" disabled="" value="{{ totImporti | euro}} &euro;" type="text"></p></div>
					</fieldset>
				</div>
				<div class="row container_fieldset">
					<fieldset class="form-group">
						<legend>Spese di lite</legend>

						<div textInputCurrency [labelInput]="'Diritti e onorari'" formControlName="compenso" [(ngModel)]="request.costoGestioneLiquidato.compenso"></div>

						<!-- <div textInputCurrency [labelInput]="'Diritti'" formControlName="diritti" [(ngModel)]="request.costoGestioneLiquidato.diritti"></div>
						
						<div textInputCurrency [labelInput]="'Onorari'" formControlName="onorari" [(ngModel)]="request.costoGestioneLiquidato.onorari"></div> -->
						
							
						<div comboModInput [labelInput]="'Aliquota CPA'" (change)="ricalcolaImporti($event,'cpa')"
						formControlName="cpa" [location]="'conteggi'" [labelOption]="'valore'" [objectReference]="request.costoGestioneLiquidato.cpa"
						(onReturn)="request.costoGestioneLiquidato.cpa = $event" [optionsCombo] ="cpaOptions"></div>
						
						<div><p class="col-sm-9 bloccodati"><label for="impo-cpa-lbl">Importo CPA</label></p>
							<p class="col-sm-3"><input id="impo-cpa-lbl" class="alignright form-control" disabled="" value="{{cpaImporto | euro}} &euro;" type="text"></p></div>
							
						<div comboModInput [labelInput]="'Aliquota IVA'" (change)="ricalcolaImporti($event,'iva')"
						formControlName="iva" [location]="'conteggi'" [labelOption]="'valore'" [objectReference]="request.costoGestioneLiquidato.iva"
						(onReturn)="request.costoGestioneLiquidato.iva = $event" [optionsCombo] ="ivaOptions"></div>
						
						<div><p class="col-sm-9 bloccodati"><label for="imp-iva-lbl">Importo IVA</label></p>
							<p class="col-sm-3"><input id="imp-iva-lbl" class="alignright form-control" disabled="" value="{{ivaImporto | euro}} &euro;" type="text"></p></div>
							
						<div>
							<p class="col-sm-9 bloccodati"><label class="fakelabel">Applica ritenuta d'acconto</label></p>
							<p class="col-sm-3 active singlecheckbox pagamenti">
								<input formControlName="flagRitenutaAcconto" id="{{'flagRitenutaAcconto' + inserimento}}" class="alignright form-control"
									[(ngModel)]="request.costoGestioneLiquidato.flagRitenutaAcconto" type="checkbox">
								<label for="{{'flagRitenutaAcconto' + inserimento}}">{{request.costoGestioneLiquidato.flagRitenutaAcconto ? 'Si' : 'No'}}</label></p>
						</div>

						<div *ngIf="request.costoGestioneLiquidato.flagRitenutaAcconto"><p class="col-sm-9 bloccodati"><label for="rit-d-acc-lbl">Ritenuta d'acconto</label></p>
							<p class="col-sm-3"><input id="rit-d-acc-lbl" class="alignright form-control" disabled="" value="{{ ritenutaAcconto | euro }} &euro;" type="text"></p></div>
							
						<div><p class="col-sm-offset-6 col-sm-3 alignright"><label for="tot-spese-lite-lbl">Totale spese di lite</label></p>
							<p class="col-sm-3"><input id="tot-spese-lite-lbl" class="alignright totale form-control" disabled="" value="{{ totSpeseLite | euro}} &euro;" type="text"></p></div>
					</fieldset>
				</div>
				<div class="row container_fieldset">
					<fieldset class="form-group">
						<legend>Altri importi</legend>
						<div textInputCurrency [labelInput]="'Spese di registrazione'" formControlName="speseRegistrazione" [(ngModel)]="request.altroImportoLiquidato.speseRegistrazione"></div>
						<div textInputCurrency [labelInput]="'Contributo unificato'" formControlName="contributoUnificato" [(ngModel)]="request.altroImportoLiquidato.contributoUnificato"></div>
						<div textInputCurrency [labelInput]="'Altro importo'" formControlName="altroImporto" [(ngModel)]="request.altroImportoLiquidato.altroImporto"></div>
						<div *ngIf="isViewTerzoPignorato" textInputCurrency [labelInput]="'Rimborso Terzo Pignorato'" 
						formControlName="rimborsoTerzoPignorato"  [(ngModel)]="request.altroImportoLiquidato.rimborsoTerzoPignorato"></div>
						<div><p class="col-sm-offset-7 col-sm-2 alignright"><label for="tot-altri-imp-lbl">Totale altri importi</label></p>
							<p class="col-sm-3"><input id="tot-altri-imp-lbl" class="alignright totale form-control" disabled="" value="{{ totAltriImporti | euro}} &euro;" type="text"></p></div>
					</fieldset>
				</div>
				<div><p class="col-sm-offset-6 col-sm-3 alignright"><label for="tot-comp-liq-lbl">Totale complessivo liquidato</label></p>
					<p class="col-sm-3"><input id="tot-comp-liq-lbl" class="alignright totale form-control" disabled="" value="{{ totComplessivo | euro}} &euro;" type="text"></p></div>
			</div>
			</div>
			</div>
			</div>
			<!-- </div>
			</div> -->
			</div>
			</div>
			</div>
		</div>
		
		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note" [(ngModel)]="request.note"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12"><em>* Campi obbligatori</em></p>
		</div>
		<div class="row">
			<div class="col-sm-3 col-xs-6">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [labelButton]="'Salva'" [disabled]="!fondoLiquidatiForm.valid"></p>
			</div>
		</div>
	</form>
	</div>
	</div>
	</ng-template>

</div>
</ng-template>